import { IOffersProposalDetail } from './interfaces';

export class IOffersProposalManager {
  private customOffersProposalEvent: CustomEvent | undefined;

  public handleOffersProposal(offersProposalDetail?: IOffersProposalDetail): void {
    this.customOffersProposalEvent = new CustomEvent('offersProposalEvent', {
      detail: offersProposalDetail,
    });
    document.dispatchEvent(this.customOffersProposalEvent);
  }
}
